import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EBuildingCraneType } from '../../../packages/api-models/common/json_query';

export const selectBuildingCranageTypesType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('building_cranage_types_type')(jsonQuery) as EBuildingCraneType[] | null,
);
